import React from "react";
import styled from "styled-components";
import IUMRSNavBar from "./IUMRSNavbar";
import { ICAMNavroute } from "../../../utils/ICAMnavroute.js";
import IUMRSFooter from "./IUMRSFooter";
import { useDesktopSiteDetection } from "../../../hooks/mobile_desktop_mode.jsx";
import { Download, BookOpen } from 'lucide-react';
import image2 from '../../../assets/speakers-img/Prof Sossina Haile.jpg'
import image4 from "../../../assets/speakers-img/Prof Ange Nzihou.jf.jpg"
import image3 from "../../../assets/speakers-img/Prof wole Soboyejo.jpg"
import image5 from "../../../assets/speakers-img/P-Scardi.jpg"
import image6 from "../../../assets/speakers-img/Dr-Peter-Ngene.jpg"
import image7 from "../../../assets/speakers-img/Prof Rudolf.png"
import image1 from "../../../assets/speakers-img/Prof Suprakas Singh.jpg"
import abstract5 from "../../../assets/plenary-abstract/Advanced methods for the study of nanocrystalline materials.pdf"
import abstract1 from "../../../assets/plenary-abstract/Translating Materials Research into Industrial Reality.pdf"
import abstract3 from "../../../assets/plenary-abstract/Next Frontiers for Artificial Intelligence for Health, Energy and Materials Design.pdf"
import abstract4 from "../../../assets/plenary-abstract/PERMANENT CARBON SINKS AND MULTIFACETED SUSTAINABLE CARBON MATERIALS.pdf"
import abstract6 from "../../../assets/plenary-abstract/Synchrotron-based X-ray Raman Scattering Studies of Interface and Interphases.pdf"




const speakers = [
  {
    name: "Prof. Suprakas Sinha Ray",
    title: "Director of the DST/CSIR National Centre for Nano-Structured Materials",
    institution: "CSIR National Centre for Nano-Structured Materials, Pretoria, South Africa.",
    description: " Suprakas Sinha Ray completed his PhD at the University of Calcutta in 2001. He was a postdoctoral fellow at Toyota Technological Institute, Japan, and Laval University, Canada, researching nanoclay-polymer nanocomposites. He joined CSIR and later became chief researcher and founding director of the DSTI-CSIR Nanotechnology Innovation Centre. His work has expanded to include more than 85 researchers, engineers, scientists, students, and industrial partners worldwide. He is a highly active author (h-factor 96, GC) in the field of nanostructured materials, recently ranked in the Top 1% of impactful scientists across 22 disciplines by Thomson Reuters, and among the top 50 chemists globally in 2011. Prof. Ray has written 14 books, co-edited 9, authored 30 book chapters on polymer-based nanostructured materials, and published over 575 articles. He holds 14 patents (granted and filed), and his team has developed 29 commercially viable technologies in collaboration with colleagues and industrial partners. Over the past 19 years, he has trained 27 postdoctoral fellows and directly supervised 43 PhD students and 23 Master's students. In 2016, he received South Africa’s prestigious NSTF Award.",
    photo: image1,
    research: [
      "Nanocomposite, composite material, polymer, chemical engineering and adsorption.",
      "Polymer blends, montmorillonite and silicate as well as nanocomposite.",
      "The connection between adsorption and Nuclear chemistry that intersect.",
    ],
    abstractTitle: "Translating Materials Research into Industrial Reality: A Technology Development Journey ",
    abstractFile: abstract1,
    abstractFileName: "IUMRS-ICAM25 Plenary - Prof. Sinha Ray.pdf"

  },
  {
    name: "Prof. Wole Soboyejo ",
    title: "President of SUNY Polytechnic Institute",
    institution: "SUNY Polytechnic Institute",
    description: "Wole Soboyejo received his BSc in mechanical engineering from King’s College London in 1985, and a PhD in materials science from Cambridge University in 1988.  He then moved to the US as a Research Scientist at the McDonnell Douglas Research Labs (1988-1992).  Since then, he has been an Assistant/Associate Professor at The Ohio State University (1992-1999), a Visiting Martin Luther King Associate Professor at MIT (1997-1998), and a Professor of Mechanical and Aerospace Engineering at Princeton University (1999-2016). Soboyejo has also served as President and Provost of the African University of Science and Technology (2012- 2014); Bernard M. Gordon Dean of Engineering (2016-2018), Provost (2018-2023) and Interim President (2023-2024) at the Worcester Polytechnic Institute (WPI).  In 2023, Soboyejo was appointed as the 7th President of the State University of New York Polytechnic Institute (SUNY Poly).  He is the author of 5 books and more than 450 peer-reviewed journal papers.  Soboyejo is a member of the US National Academy of Engineering, a Fellow of the World Academy of Science, the African Academy of Science, the Nigerian Academy of Science, the Nigerian Academy of Engineering, the American Society of Mechanical Engineers, the American Institute for Medical and Biological Engineering and the Materials Society of Nigeria.",
    photo: image3,
    research: [
      "Mechanical properties of High Entropy Alloys (HEAs) and recycled HEAs",
      "Perovskite solar cells and Li Ion batteries",
      "Multi-functional materials",
      "AI/ML-guided solutions to grand challenges in health, energy and the environment."
    ],
    abstractTitle: "Next Frontiers for Artificial Intelligence for Health, Energy and Materials Design",
    abstractFile: abstract3,
    abstractFileName: "IUMRS-ICAM25 Plenary - Prof. Soboyejo.pdf"
  },
  {
    name: "Prof. Ange Nzihou",
    title: "Professor of Chemical and Environmental Engineering",
    institution: "IMT Mines Albi (France)",
    description: "Professor Ange Nzihou is a Distinguished Professor of Chemical and Environmental Engineering as well as a Laureate of the ERC Advanced Grant, the European most prestigious research funding. He is a Fulbright Fellow and visiting Professor at Princeton University (USA). He is also a visiting Professor at Zhejiang University (China), Mahatma Gandhi University (India) and the University of Pretoria (South Africa).He is the Professorial Chair holder of the Nobel laureates J. B. Goodenough, M. S. Whittingham and A. Yoshino on Sustainable Energy Materials at Mahatma Gandhi University (India). He is the Editor-in-Chief of the peer-reviewed journal on Waste and Biomass Valorization. He is the Founder and Chair of the WasteEng International Conference Series as well as a Fulbright Program Ambassador (2024 – 2025).",
    photo: image4,
    research: [
      "Sustainable carbon-based functional materials (graphene, sensors, catalysts, energy carriers)",
      "Hydrogen, Syngas, Fuel from renewable resources",
      "Thermochemical processes (pyrolysis, gasification, reforming, carbonization",
      "Elaboration, functionalization phosphate based composites"
    ],
    abstractTitle: "Biocarbon Allotropes: Permanent Carbon Sinks And Multifaceted Sustainable Carbon Materials",
    abstractFile: abstract4,
    abstractFileName: "IUMRS-ICAM25 Plenary - Prof. Nzihou.pdf"

  },
  {
    name: "Prof. Sossina Haile",
    title: "Professor of Materials Science and Engineering",
    institution: "Northwestern University",
    description: "Sossina Haile received her B.S and Ph.D (1992) from the Massachusetts Institute of Technology, and M.S. from the University of California, Berkeley. She carried out postdoctoral research at the Max Planck Institut für Festkörperforschung [Institute for Solid State Research], Stuttgart, Germany (1992-1993) as a Humboldt Fellow. Haile joined Northwestern University in 2015, after having served 18 years on the faculty at the California Institute of Technology. She is the recipient of several awards, including in 2008 an American Competitiveness and Innovation (ACI) Fellowship from the National Science Foundation in recognition of “her timely and transformative research in the energy field and her dedication to inclusive mentoring, education and outreach across many levels,” the 2010 Chemical Pioneers Award of the Chemical Heritage Foundation, and the 2012 International Ceramics Prize for the World Academy of Ceramics. In 2016 she was inducted into the African Academy of Sciences.",
    photo: image2,
    research: [
      "Solid state ionic materials and devices",
      "Fuel cells based on solid acid electrolytes",
      "Power densities for solid oxide fuel cells",
    ],
    abstractTitle: "Abstract Unavailable",
    abstractFileName: "IUMRS-ICAM25 Plenary - Prof. Haile.pdf"

  },
  {
    name: "Prof. Paolo Scardi",
    title: "Professor of Materials Science and Technology",
    institution: "University of Trento",
    description: "Prof Paolo Scardi graduated in Physics (Solid State), at the University of Naples in 1985 defending the experimental thesis 'Effects of disorder in superconductivity'. He is a full professor of Materials Science and Technology at the University of Trento since 2002 with over 38 years of research experience. He is a past Chairman of the European Powder Diffraction Conference (EPDIC) committee and of the IUCr Commission on Powder Diffraction and a winner of the Hanawalt award for 2016 and EPDIC award for distinguished powder diffractionist for 2024. He is an author of over 350 articles with more than 17000 citations.",
    photo: image5,
    research: [
      "X-ray powder diffraction methods and applications",
      "Nanocrystalline materials",
      "Energy materials (thin film photovoltaic cells, fuel cells, water splitting, nanocrystalline catalysts, thermoelectrics). ",
      "Atomistic modelling "
    ],
    abstractTitle: "Advanced methods for the study of nanocrystalline materials using X-ray Diffraction ",
    abstractFile: abstract5,
    abstractFileName: "IUMRS-ICAM25 Plenary - Prof. Scardi.pdf"

  },
  {
    name: "Prof. Peter Ngene",
    title: "Associate Professor of Inorganic Chemistry and Catalysis",
    institution: "Debye Institute of Nanomaterials Science at the Utrecht University, Utrecht, Netherlands",
    description: "Dr. Peter Ngene is Associate Professor of Inorganic Chemistry and Catalysis at the Debye Institute of Nanomaterials Science at the Utrecht University, Utrecht, Netherlands. He had his B.Sc. Hons. Degree in Chemical Engineering, Federal University of technology Owerri (FUTO), Nigeria, a MSc (MEMS) Micro- and Nano-Systems Engineering, ESIEE- Paris and Nanyang Technological University (NTU) Singapore and a PhD, Inorganic Chemistry and Catalysis, Utrecht University in 2011. He is the recipient of the Van Akel Best PHD thesis Award in 2013. He was also recently recognised as the African Leading Young Scientist with the award of Next Einstein Forum (NEF) Fellowship by the Chairman of African Union, His Excellency, Paul Kegame.",
    photo: image6,
    research: [
      "Complex metal hydrides",
      "Hydride-based solid-state batteries",
      "Advanced hydrogen storage materials ans",
      "Solid-state electrolytes and nanostructured energy systems"
    ],
    abstractTitle: "Synchrotron-based X-ray Raman Scattering Studies of Interface and Interphases in Next-Generation Batteries based on Nanocomposite Solid Electrolytes ",
    abstractFile: abstract6, 
    abstractFileName: "IUMRS-ICAM25 Plenary - Prof. Ngene.pdf"

  },
  {
    name: "Prof. Petra Rudolf",
    title: "Professor in Experimental Solid State Physics",
    institution: "University of Groningen, Netherlands",
    description: "Prof Petra Rudolf receive her MSc degree (magna cum laude) in physics at the Sapienza University of Rome, Italy. In 1995, she received her PhD (magna cum laude) in physics at Facultés Universitaires Notre-Dame de la Paix, Namur, Belgium. After several research positions, she became a professor in Experimental Solid State Physics at the University of Groningen in 2003 where she is currently Dean of Graduate studies. Rudolf has been elected to offices in professional organizations including President of the Belgian Physical Society from 2000 to 2001, President of the European Physical Society from 2019 to 2020 and chair of the EPS Equal Opportunities Committee,  Member of the Scientific Advisory Committees of the Max Planck Institute Structure and Dynamics of Matter, Hamburg 2020-2026; the SOLARIS National Synchrotron Radiation Centre, Kraków, since 2018; the Centre of Advanced Materials, Heidelberg University, since 2017; the HFML-FELIX Collaborative Alliance (2020-2023) amongst others.",
    photo: image7,
    research: [
      "Surface physics of organic thin films",
      "Nanocomposites and 2D materials",
      "Carbon/graphene-based materials"
    ],
    abstractTitle: "Abstract Unavailable",
    abstractFileName: "IUMRS-ICAM25 Plenary - Prof. Rudolf.pdf"

  }
];


const PlenaryDetails = () => {

    const isDesktopSiteOnMobile = useDesktopSiteDetection()

    return(
        <Container>
            <IUMRSNavBar navroute={ICAMNavroute}/>

            <Body className={isDesktopSiteOnMobile ? 'desktop-site-mode' : ''}>

                <MaxWidth>
                    <Header>
                    <Title>
                        Plenary <TitleHighlight>Speakers</TitleHighlight>
                    </Title>
                    <Subtitle>19th International Conference on Advanced Materials (ICAM)</Subtitle>
                    </Header>
                    
                    <Grid>
                    {speakers.map((speaker, index) => (
                        <Card key={index}>
                        <TopSection>
                            <PhotoWrapper>
                            <Photo>
                                <img src={speaker.photo} alt={speaker.name} />
                            </Photo>
                            <IconBadge>
                                <BookOpen />
                            </IconBadge>
                            </PhotoWrapper>
                            
                            <InfoSection>
                            <Name>{speaker.name}</Name>
                            <Position>{speaker.title}</Position>
                            <Institution>{speaker.institution}</Institution>
                            </InfoSection>
                        </TopSection>
                        
                        <Divider />
                        
                        <Description>{speaker.description}</Description>
                        
                        <ResearchSection>
                            <ResearchTitle>Research Interests</ResearchTitle>
                            <ResearchList>
                            {speaker.research.map((item, idx) => (
                                <ResearchItem key={idx}>{item}</ResearchItem>
                            ))}
                            </ResearchList>
                        </ResearchSection>
                        
                        <AbstractSection>
                            <ViewButton onClick={ () => speaker.abstractFile && window.open(speaker.abstractFile)} >                                            
                            <AbstractInfo>
                                <AbstractLabel>View Abstract</AbstractLabel>
                                <AbstractTitle>{speaker.abstractTitle}</AbstractTitle>
                            </AbstractInfo>
                            </ViewButton>
                        </AbstractSection>
                        </Card>
                    ))}
                    </Grid>
                </MaxWidth>

            </Body>

            <IUMRSFooter />

        </Container>
    )

}
const Container = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #ffffff 0%, #f0f4f8 100%);

`

const Body = styled.div`

`;

const MaxWidth = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Header = styled.header`
  text-align: center;
  margin-bottom: 80px;
`;

const Title = styled.h1`
  font-size: 3.5rem;
  font-weight: 700;
  color: #082D4A;
  margin-bottom: 16px;
  letter-spacing: -1px;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
  }
`;

const TitleHighlight = styled.span`
  position: relative;
  
  &:after {
    content: '';
    position: absolute;
    bottom: 8px;
    left: 0;
    right: 0;
    height: 12px;
    background: rgba(8, 45, 74, 0.15);
    z-index: -1;
  }
`;

const Subtitle = styled.p`
  font-size: 1.25rem;
  color: #4a5f7a;
  font-weight: 500;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
  gap: 40px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const Card = styled.div`
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 40px rgba(8, 45, 74, 0.08);
  border: 2px solid transparent;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;

  display: flex;
  flex-direction: column;

  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 6px;
    background: linear-gradient(90deg, #082D4A 8%, #1a4d6f 100%);
  }
  
  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 20px 60px rgba(8, 45, 74, 0.15);
    border-color: #082D4A;
  }
`;

const TopSection = styled.div`
  display: flex;
  align-items: start;
  gap: 24px;
  margin-bottom: 28px;
`;

const PhotoWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
`;

const Photo = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 16px;
  overflow: hidden;
  border: 4px solid #082D4A;
  box-shadow: 0 8px 24px rgba(8, 45, 74, 0.2);
  transition: transform 0.3s ease;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  ${Card}:hover & {
    transform: scale(1.05);
  }
`;

const IconBadge = styled.div`
  position: absolute;
  bottom: -8px;
  right: -8px;
  width: 40px;
  height: 40px;
  background: #082D4A;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(8, 45, 74, 0.3);
  
  svg {
    color: white;
    width: 20px;
    height: 20px;
  }
`;

const InfoSection = styled.div`
  flex: 1;
  min-width: 0;
`;

const Name = styled.h2`
  font-size: 1.75rem;
  font-weight: 700;
  color: #082D4A;
  margin-bottom: 8px;
  transition: color 0.3s ease;
  
  ${Card}:hover & {
    color: #0a3d5c;
  }
`;

const Position = styled.h3`
  font-size: 0.95rem;
  color: #4a5f7a;
  margin-bottom: 6px;
  font-weight: 500;
`;

const Institution = styled.p`
  font-size: 0.85rem;
  color: #6b7f99;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const Divider = styled.div`
  height: 1px;
  background: linear-gradient(90deg, transparent 0%, rgba(8, 45, 74, 0.2) 50%, transparent 100%);
  margin: 24px 0;
`;

const Description = styled.p`
  font-size: 0.95rem;
  color: #2c3e50;
  line-height: 1.7;
  margin-bottom: 24px;
`;

const ResearchSection = styled.div`
  margin-bottom: 28px;
`;

const ResearchTitle = styled.h4`
  font-size: 0.85rem;
  font-weight: 700;
  color: #082D4A;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  
  &:before {
    content: '';
    width: 24px;
    height: 2px;
    background: #082D4A;
  }
`;

const ResearchList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ResearchItem = styled.li`
  font-size: 0.9rem;
  color: #4a5f7a;
  margin-bottom: 10px;
  padding-left: 24px;
  position: relative;
  line-height: 1.6;
  
  &:before {
    content: "◆";
    position: absolute;
    left: 0;
    color: #082D4A;
    font-size: 0.8rem;
  }
`;

const AbstractSection = styled.div`
  padding-top: 24px;
  border-top: 2px solid rgba(8, 45, 74, 0.1);
  margin-top: auto;
`;

const ViewButton = styled.button`
  width: 100%;
  background: #082D4A;
  color: white;
  font-weight: 600;
  padding: 16px 24px;
  border-radius: 12px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  box-shadow: 0 4px 16px rgba(8, 45, 74, 0.2);
  transition: all 0.3s ease;
  
  &:hover {
    background: #0a3d5c;
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(8, 45, 74, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
  
  svg {
    width: 20px;
    height: 20px;
    transition: transform 0.3s ease;
  }
  
  &:hover svg {
    transform: translateY(2px);
  }
`;

const AbstractInfo = styled.div`
  text-align: left;
  flex: 1;
`;

const AbstractLabel = styled.div`
  font-size: 0.75rem;
  opacity: 0.9;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

const AbstractTitle = styled.div`
  font-size: 0.95rem;
  font-weight: 700;
  margin-top: 2px;
`;

export default PlenaryDetails
